"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const env_1 = require("../../../env");
const baseStatusUrl = () => (0, env_1.getEnv)("STATUS_API_URL");
const statusVersion = () => (0, env_1.getEnv)("STATUS_API_VERSION");
function fetchStatusSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const url = `${baseStatusUrl()}/v${statusVersion()}/summary.json`;
        const { data } = yield (0, network_1.default)({
            method: "GET",
            url,
        });
        return data;
    });
}
const api = {
    fetchStatusSummary,
};
exports.default = api;
//# sourceMappingURL=api.js.map